import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

import SidebarPanel from '../../components/SidebarPanel';
import Switch from '../../components/FormFields/Switch';

import classes from './ScoreTogglePanel.module.css';

const ScoreTogglePanel = ({toggleScoring, scoringEnabled, isScoringLoading}) => (
    <SidebarPanel
        title="Scoring"
        titleIconSrc="/assets/images/scoringFlat.svg"
    >
        <List>
            <ListItem disableGutters>
                <ListItemText
                    classes={{
                        primary: classes.listItemText
                    }}
                >
                    Enabled
                </ListItemText>
                <ListItemSecondaryAction>
                    <Switch
                        checked={scoringEnabled}
                        name="enabled"
                        onChange={toggleScoring}
                        isLoading={isScoringLoading}
                    />
                </ListItemSecondaryAction>
            </ListItem>
        </List>
    </SidebarPanel>
);

export default ScoreTogglePanel;
